<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small color="white accent--text" :loading="loading" tile @click="createJob">Create Job</v-btn>
            </v-toolbar>
        </v-card>
        <v-card tile>
            <v-tabs
            v-model="tab"
            background-color="primary"
            dark
            center-active
            show-arrows
            >
                <v-tab>Personal</v-tab>
                <v-tab>Quote</v-tab>
                <v-tab>Comments</v-tab>
                <v-tab>Images</v-tab>
                <v-tab>Activity Log</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card flat tile color="#004889">
                        <v-card-text class="pa-0">
                            <v-form ref="estimatorFields" color="#004889">
                                <v-list flat color="#004889" class="py-0">
                                    <v-list-item class="form-row">
                                        <v-list-item-content class="label">
                                            <v-list-item-title class="white--text font-weight-bold">Estimator</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-combobox
                                                v-model="form.estimator"
                                                :items="estimators"
                                                item-text="name"
                                                item-value="id"
                                                solo
                                                dark
                                                flat
                                                @change="submit"
                                                clearable
                                            ></v-combobox>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item class="form-row">
                                        <v-list-item-content class="label">
                                            <v-list-item-title class="white--text font-weight-bold">Meeting Date/Time</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-datetime-picker v-model="form.datetime" date-format="MM/dd/yyyy" time-format="hh:mm a" solo dark flat></v-datetime-picker>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-list-item class="form-row">
                                        <v-list-item-content class="label">
                                            <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-select
                                                v-model="form.status"
                                                :items="filteredStatuses"
                                                item-text="label"
                                                item-value="value"
                                                solo
                                                dark
                                                flat
                                                @change="submit"
                                            ></v-select>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn large min-width="100%" color="white accent--text"  @click="submit" :loading="loading" tile>Update</v-btn>
                        </v-card-actions> 
                    </v-card>
                    <v-card flat tile color="#004889">
                        <v-card-text class="pa-0">
                            <ValidationObserver ref="observer1">
                                <v-form ref="personalform">
                                    <v-list flat color="#004889" class="py-0">
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">First Name</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                                                    <v-text-field
                                                    v-model="form.first_name"
                                                    :error-messages="errors"
                                                    required
                                                    solo
                                                    dark
                                                    flat
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Last Name</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                                                    <v-text-field
                                                    v-model="form.last_name"
                                                    :error-messages="errors"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Email</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                                                    <v-text-field
                                                    v-model="form.email"
                                                    :error-messages="errors"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Phone</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                                    <v-text-field
                                                    v-model="form.phone"
                                                    :error-messages="errors"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Street Address</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                    <v-text-field
                                                    v-model="form.street_address"
                                                    :error-messages="errors"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">City</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                    <v-text-field
                                                    v-model="form.city"
                                                    :error-messages="errors"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Zip Code</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                    <v-text-field
                                                    v-model="form.zip"
                                                    :error-messages="errors"
                                                    solo
                                                    dark
                                                    flat
                                                    required
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">County</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="County" rules="required">
                                                    <v-autocomplete
                                                        :items="counties"
                                                        :filter="customFilter"
                                                        :error-messages="errors"
                                                        v-model="form.county"
                                                        color="white"
                                                        item-text="title"
                                                        item-value="id"
                                                        label="County"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                    ></v-autocomplete>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Preffered Contact Method</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Preffered Contact Method" rules="required">
                                                    <v-select
                                                        v-model="form.preffered_contact"
                                                        :items="preffered_contact"
                                                        item-text="label"
                                                        item-value="value"
                                                        :error-messages="errors"
                                                        solo
                                                        flat
                                                        dark
                                                        data-vv-name="preffered_contact"
                                                        required
                                                    ></v-select>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Best Time to Contact</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Best Time to Contact" rules="required">
                                                    <v-select
                                                        v-model="form.preffered_time"
                                                        :items="preffered_time"
                                                        item-text="label"
                                                        item-value="value"
                                                        :error-messages="errors"
                                                        solo
                                                        flat
                                                        dark
                                                        data-vv-name="preffered_time"
                                                        required
                                                    ></v-select>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">How did they hear about Mr. Pool</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="How did they hear about Mr. Pool" rules="required">
                                                    <v-select
                                                        v-model="form.how_did_hear"
                                                        :items="how_did_hear"
                                                        item-text="label"
                                                        item-value="value"
                                                        :error-messages="errors"
                                                        solo
                                                        flat
                                                        dark
                                                        data-vv-name="how_did_hear"
                                                        required
                                                    ></v-select>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-form>
                            </ValidationObserver>
                        </v-card-text>
                        <v-card-actions>                        
                            <v-btn large min-width="100%" color="white accent--text"  @click="submit" :loading="loading" tile>Update</v-btn>     
                        </v-card-actions>  
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat tile color="#004889">
                        <v-toolbar flat dark color="#003e72" class="quote-bar" tile>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn dark text class="title font-weight-bold">Estimation: {{ subTotal | currency }}</v-btn>
                            </v-toolbar-items>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="pa-0">
                            <ValidationObserver ref="observer2">
                                <v-form ref="calform">
                                    <v-list two-line subheader flat color="#004889" class="py-0">
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Pool Shape</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Shape" rules="required">
                                                    <v-select
                                                        v-model="form.shape"
                                                        :items="shapes"
                                                        item-text="title"
                                                        item-value="id"
                                                        :error-messages="errors"
                                                        solo
                                                        flat
                                                        dark
                                                        data-vv-name="type"
                                                        required
                                                        @change="calTotal"
                                                    ></v-select>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Pool Size</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Size" rules="required">
                                                    <v-select
                                                        v-model="form.size"
                                                        :items="sizes"
                                                        item-text="title"
                                                        item-value="id"
                                                        :error-messages="errors"
                                                        solo
                                                        flat
                                                        dark
                                                        data-vv-name="size"
                                                        required
                                                        @change="calTotal"
                                                    ></v-select>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Pool Addons</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-select
                                                    v-model="form.pooloptions"
                                                    :items="options"
                                                    item-text="title"
                                                    item-value="id"
                                                    multiple
                                                    small-chips
                                                    solo
                                                    flat
                                                    dark
                                                    hide-details
                                                >
                                                </v-select>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </v-form>
                            </ValidationObserver>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn large min-width="100%" color="white accent--text"  @click="submit" :loading="loading" tile>Update</v-btn>               
                        </v-card-actions> 
                    </v-card>
                </v-tab-item>
                <v-tab-item>                
                    <Comment v-for="(comment, index) in form.comments" :key="index" :item="comment" @set-parent="replyComment"/>
                    <v-divider></v-divider>
                    <v-card flat tile class="comment-form">
                        <v-card-text>
                            <v-form ref="commentform">
                                <v-chip
                                v-if="comment.parent"
                                class="mb-3"
                                close
                                @click:close="comment.parent = null"
                                small
                                >
                                    Replying to: {{ activeComment | truncate(20, '...') }}
                                </v-chip>
                                <v-textarea
                                    outlined
                                    ref="comment"
                                    v-model="comment.comment"
                                    label="Comment"    
                                    hide-details
                                    auto-grow
                                    rows="1"                             
                                ></v-textarea>
                                <v-checkbox
                                    v-model="comment.public"
                                    v-if="comment.parent == null"
                                    label="Make Public & Notify Customer"
                                    hide-details
                                    class="mt-1 public"
                                    ripple="false"
                                ></v-checkbox>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="admin-action">
                            <v-spacer></v-spacer>
                            <v-btn large text tile elevation="0" @click="sendComment" :loading="loading">Submit</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions> 
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat tile>
                        <v-card-text>
                            <file-pond
                                name="filepond"
                                ref="filepond"
                                label-idle='Backyard Photo (Pool Location)<br/>Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                v-bind:allow-multiple="true"
                                accepted-file-types="image/jpeg, image/png"
                                :server="{
                                    url: 'https://api.mrpoolal.com/api/data/lead/image?id='+id,
                                    process: {
                                        headers: {
                                            'Authorization': `Bearer ${token}`
                                        }
                                    }
                                }"
                                v-bind:files="files"
                                v-on:init="handleFilePondInit"
                                v-on:processfile="handleFilePondProcessfile"/>
                        </v-card-text>
                    </v-card>
                    <v-card flat tile>
                        <v-card-text>
                            <div v-viewer="voptions" class="images clearfix">
                                <template v-for="(source, index) in form.images">
                                    <img :src="source.thumb" :data-source="source.src" class="image" :key="index">
                                </template>
                            </div>

                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat tile>
                        <template v-for="(activity, index) in form.activities">
                            <v-list-item two-line :key="index" :class="activity.properties.type">
                                <v-list-item-content>
                                    <v-list-item-title>{{ activity.description }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ activity.created_at }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider
                            :key="index + 'divider'"
                            ></v-divider>
                        </template>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'
import TokenService from '../services/storage.service'
import Comment from '../components/Comment.vue'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['id'],
    data () {
        return {
            voptions: {
                toolbar: true,
                url: 'data-source'
            },
            requiredValue: true,
            files: [],
            uploadedFiles: [],
            tab: null,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                preffered_contact: '',
                preffered_time: '',
                how_did_hear: '',
                service: 'New Pool Construction',
                size: null,
                county: null,
                pooloptions: [],
                images: [],
                estimator: null,
                status: '',
                datetime: ""
            },
            optionsPrice: 0,
            totalPrice: 0,
            loading: false,
            comment: {
                comment: '',
                public: false,
                parent: null,
                type: 'comment'
            },
            token: '',
            pageTitle: '',
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.getLead()
        this.token = TokenService.getToken()
    },
    computed: {
        ...mapGetters({
            counties: 'data/counties',
            sizes: 'data/sizes',
            options: 'data/options',
            states: 'data/states',
            preffered_time: 'data/preffered_time',
            preffered_contact: 'data/preffered_contact',
            how_did_hear: 'data/how_did_hear',
            filteredOptions: 'data/filteredOptions',
            requiredOptions: 'data/requiredOptions',
            requiredTotal: 'data/requiredTotal',
            estimators: 'data/estimators',
            statuses: 'data/statusArray',
        }),
        filteredStatuses() {
            return this.statuses.filter(status => {
                return status.value != 'all'
            })
        },
        calToggle: {
            get() {
                return this.dialog
            },
            set(newValue) {
                this.$store.commit('menu/SET_CAL_DIALOG', newValue)
            }
        },
        sizePrice() {
            let sizePrice = 0

            if(this.form.size !== null) {
                let sizeArr = this.sizes.filter(size => {
                    return size.id == this.form.size
                })

                if(sizeArr[0] !== undefined)
                    sizePrice += parseFloat(sizeArr[0].price) + this.requiredTotal
            }

            return sizePrice 
        },
        countyPrice() {
            let countyPrice = 0

            if(this.form.county !== null) {
                let countyArr = this.counties.filter(county => {
                    return county.id == this.form.county
                })

                if(countyArr[0] !== undefined)
                    countyPrice += parseFloat(countyArr[0].price)
            }

            return countyPrice
        },
        optionsTotal() {
            let optionsTotal = 0
            this.form.pooloptions.forEach(option => {
                let optionArr = this.filteredOptions.filter(fo => {
                    return fo.id == option
                })

                if(optionArr[0] !== undefined)
                    optionsTotal += parseFloat(optionArr[0].price)
                
            })
            return optionsTotal
        },
        subTotal() {
            return this.sizePrice + this.countyPrice + this.optionsTotal
        },
        activeComment() {
            let active = this.form.comments.filter(comment => {
                return comment.id == this.comment.parent
            })

            if(active.length > 0) {
                return active[0].comment
            } else {
                return ''
            }
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        Comment
    },
    methods: {
        customFilter (item, queryText) {
            const textOne = item.title.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1
        },
        getLead() {
            if(this.id) {
                axios.get('estimator/leads/get?id=' + this.id)
                    .then((response) => {
                        this.form = response.data

                        if(response.data.schedule !== null)
                            this.form.datetime = new Date(response.data.schedule)

                        this.form.status = response.data.status
                        this.$nextTick()
                    })
            }
        },
        ...mapActions({
            updateLead: 'data/updateLead',
            addComment: 'data/addComment'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateLead(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
        async sendComment() {
            this.loading = true
            this.addComment({
                id: this.id, 
                comment: this.comment.comment, 
                public: this.comment.public, 
                parent: this.comment.parent,
                type: this.comment.type
            }).then(response => {
                this.loading = false
                if(response.parent) {
                    let filteredComment = this.form.comments.filter(comment => {
                        return comment.id == response.parent
                    })

                    filteredComment[0].children.unshift(response)
                } else {
                    this.form.comments.unshift(response)
                }
                this.comment.comment = ''
                this.comment.public = false
                this.comment.parent = null
                this.$store.commit('SET_SNACKTYPE', 'green')
                this.$store.commit('SET_SNACK', 'Successfully saved')
            }).catch(() => {
                this.loading = false
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Failed to save your comment! Please try again.')
            })
        },
        replyComment(parent, type) {
            this.comment.parent = parent
            this.comment.type = type
            const el = this.$el.getElementsByClassName('comment-form')[0]

            if (el) {
                el.scrollIntoView({behavior: 'smooth'})                
                this.$nextTick(() => this.$refs.comment.$refs.input.focus())
            }
        },
        handleFilePondProcessfile: function (error, file) {
            if(this.form.images !== undefined)
                this.form.images.push({
                    thumb: 'https://api.mrpoolal.com/img/backyards/' + file.serverId + '?w=400&h=400&fit=crop',
                    src: 'https://api.mrpoolal.com/img/backyards/' + file.serverId + '?w=1200',
                })  
                this.$nextTick()
        },
        createJob() {
            this.$router.push({ name: 'New Job', params: { customer: this.form } })
        }
    }
}
</script>

<style lang="sass" scoped>
.estimation
    background: #003e72
    color: #fff
    text-align: center
    justify-content: center
    font-size: 20px
    margin: -16px -16px 20px
header
    &.quote-bar
        position: sticky
        top: 0
        z-index: 999
.admin-action 
    background: #1976d2
    button 
        width: 100%
        background: #ffffff
        color: #1976d2
.comment-actions 
    background: #dadada
</style>
<style lang="sass">
.filepond--drop-label
    &.filepond--drop-label label
        margin: 0
        color: #fff
        font-size: 20px
        text-transform: uppercase
        font-size: 18px
        line-height: 1em
        font-weight: 800

.filepond--panel-root
    background: #003a6f
    border-radius: 0
    color: #fff!important
    border: none!important

.filepond--panel-center
    &.filepond--panel-root
        outline: 3px dashed #fff
        outline-offset: -10px

.images
    text-align: center
    display: grid
    grid-template-columns: auto auto auto auto

    img 
        width: 100%

.comment-text
    white-space: pre-wrap

.public
    label 
        font-size: 13px

.theme--light
    &.status
        background: #e0f2f5
</style>